import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <Section background="charcoal" className="text-center relative overflow-hidden" data-id="element-10">
      {/* Gold accent background */}
      <div className="absolute top-0 left-0 w-full h-2 bg-[#C5A55A]" data-id="element-11" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#C5A55A] rounded-full opacity-10 blur-3xl transform translate-y-1/2 translate-x-1/2" data-id="element-12" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="relative z-10 max-w-3xl mx-auto" data-id="element-13">
        <h2 className="font-serif text-3xl md:text-5xl text-white mb-6 leading-tight" data-id="element-14">
          Dejá de perder ventas en el{' '}
          <span className="text-[#C5A55A]" data-id="element-15">último mensaje</span>
        </h2>

        <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-16">
          Cada consulta que no cerrás es plata que se va. Con el Kit DM Que
          Cierra, tenés las palabras exactas para convertir.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-17">
          <Button variant="primary" size="lg" className="w-full md:w-auto text-lg px-12 py-5" icon href="https://www.mujerdigital2.com/cart/42527848693847:1" data-id="element-18">
            QUIERO EL KIT AHORA
          </Button>

          <div className="flex items-center justify-center gap-3" data-id="element-19">
            <span className="bg-red-500 text-white text-sm font-bold px-2 py-1 rounded" data-id="element-20">
              -50%
            </span>
            <span className="text-xl md:text-2xl text-gray-500 line-through" data-id="element-21">
              $19.980
            </span>
            <span className="text-3xl md:text-4xl font-bold text-[#C5A55A]" data-id="element-22">
              $9.990
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400 uppercase tracking-wider" data-id="element-23">
            <span className="flex items-center gap-2" data-id="element-24">
              <ShieldCheck size={16} className="text-[#C5A55A]" data-id="element-25" /> Acceso
              inmediato
            </span>
            <span className="hidden md:inline" data-id="element-26">•</span>
            <span className="flex items-center gap-2" data-id="element-27">
              <ShieldCheck size={16} className="text-[#C5A55A]" data-id="element-28" /> Garantía 7
              días
            </span>
            <span className="hidden md:inline" data-id="element-29">•</span>
            <span className="flex items-center gap-2" data-id="element-30">
              <ShieldCheck size={16} className="text-[#C5A55A]" data-id="element-31" /> Soporte por
              email
            </span>
          </div>
        </div>
      </motion.div>
    </Section>;
}